import NotificationsIcon from '@mui/icons-material/Notifications';
import { AppBar, Badge, Box, IconButton, Toolbar, Tooltip, Typography } from '@mui/material';
import { docGeniusPalette } from 'styles/partials/colors';
import { Hierarchies, Hierarchy } from 'styles/partials/hierarchies';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import React from 'react';
import { useAppDispatch } from 'app/hooks';
import { logout } from 'features/auth/authSlice';
import MenuButton from '../MenuButton/MenuButton';
import { AccountCircleRounded, KeyboardArrowDownRounded } from '@mui/icons-material';

const whiteTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#FFFFFF',
    },
  },
});

interface Props {
  label: string;
  notificationsCount?: number;
  navbarWidth?: number;
}

const TYPE_SALESFORCE = 'salesforce';

export const AzulNavBar: React.FC<Props> = ({ label, notificationsCount, navbarWidth = 0 }) => {
  const optionsHierarchy = Hierarchies[Hierarchy.Hierarchy4];
  const dispatch = useAppDispatch();

  const validateAuthSalesforceType = () => {
    const url: string = window.location.href;
    const urlParts = url.split('/');
    const firstFourParts = urlParts.slice(0, 4).join('/');
    return firstFourParts.toLocaleLowerCase().includes(TYPE_SALESFORCE);
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <ThemeProvider theme={whiteTheme}>
        <AppBar
          position='fixed'
          sx={{
            boxShadow: `${optionsHierarchy.shadow} rgba(${optionsHierarchy.rgba})`,
            width: { sm: `calc(100% - ${navbarWidth}px)` },
            ml: { sm: `${navbarWidth}px` },
          }}
        >
          <Toolbar>
            <Typography
              fontFamily={'Rubik'}
              fontWeight={500}
              fontSize={'16px'}
              color={docGeniusPalette.primaryBlue}
              margin='16px 64px'
              noWrap
              variant='h3'
            >
              {label}
            </Typography>

            <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
              <IconButton
                aria-label='notificationLabel'
                sx={{
                  color: docGeniusPalette.primaryBlue,
                  marginRight: '4px',
                }}
              >
                <Badge badgeContent={notificationsCount} color='error' overlap='circular'>
                  <Tooltip title='Notifications' arrow>
                    <NotificationsIcon />
                  </Tooltip>
                </Badge>
              </IconButton>

              {!validateAuthSalesforceType() && (
                <MenuButton
                  options={[
                    {
                      item: <div>Logout</div>,
                      handler: () => {
                        dispatch(logout());
                      },
                    },
                  ]}
                >
                  <Tooltip title='Account' arrow>
                    <Box alignItems={'center'} display={'flex'}>
                      <AccountCircleRounded />
                      <KeyboardArrowDownRounded />
                    </Box>
                  </Tooltip>
                </MenuButton>
              )}
            </Box>
          </Toolbar>
        </AppBar>
      </ThemeProvider>
    </Box>
  );
};
